import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Category from '@shared/models/category.model';
import { Product } from '@shared/models/product.model';
import { ProductSkuFilterRequest } from '@shared/models/request/product-sku-filter-request';
import { NavigationService } from '@shared/services/navigation.service';
import { ProductsService } from '@shared/services/products.service';
import { SessionStoreService } from '@shared/services/session-store.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  products: Product[]

  category: Category = new Category()

  parentCategory: Category = new Category()

  breadcrumb: Category[] = []

  resolverReady: boolean = false

  sortBy = [
    "New Arrivals",
    "Most Popular",
    "Price Low to High",
    "Price High to Low"
  ]

  categoryIdParam: number;

  //Filter
  currentPage: number = 0;
  totalPageNum: number = 0;
  sort: string = "displayOrder,id";
  selectedSort: string = ""
  order: string = "desc";
  filter: ProductSkuFilterRequest = new ProductSkuFilterRequest()

  constructor(private route: ActivatedRoute, private router: Router, private ss: SessionStoreService, private navigationService: NavigationService, private productService: ProductsService) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.categoryIdParam = +params.get('categoryId')
    })

    this.route.data.subscribe((data: { products: any }) => {
      this.resetFilter()

      this.products = data.products.content

      this.totalPageNum = data.products.totalPages

      this.currentPage = data.products.number


      const list: Category[] = this.ss.getItem("categoryList")
      if(list && list.length > 0) {
        if(this.categoryIdParam !== 0) {
          //Create breadcrumb
          this.breadcrumb = []
          this.category = list.find(cat => cat.id === this.categoryIdParam)
          const parent = this.category.path.split("/")
          //Shift away the root category
          parent.shift()
          //Men or Women
          this.parentCategory = list.find(cat => cat.key === parent[0])
          const parentPath = this.parentCategory.path;
          parent.map(key => {
            this.breadcrumb.push(list.find(cat => cat.key === key && cat.path.includes(parentPath)))
          })
        }
      }
    })

    //For the first time load into product list
    this.navigationService.categoryItems$.subscribe(list => {
      const sslist: Category[] = this.ss.getItem("categoryList")
      if(!sslist && list && list.length > 0 && this.categoryIdParam !== 0) {
          //Create breadcrumb
          this.breadcrumb = []
          this.category = list.find(cat => cat.id === this.categoryIdParam)
          const parent = this.category.path.split("/")
          //Shift away the root category
          parent.shift()
          //Men or Women
          this.parentCategory = list.find(cat => cat.key === parent[0])
          parent.map(key => {
            this.breadcrumb.push(list.find(cat => cat.key === key))
          })
      }
    })


    //Read Route params
    this.route.queryParamMap.subscribe(params => {
      const sortBy = params.get("sortBy")
      const order = params.get("order")

      if(sortBy && order) {
        this.selectedSort = this.getDropdownValueBySortAndOrder(sortBy, order)
        this.sort = sortBy
        this.order = order
      }

      if(params.keys.length > 0 && this.resolverReady && this.categoryIdParam === +this.route.snapshot.params.categoryId) {
        this.filter = new ProductSkuFilterRequest()
        this.filter.isSale = params.get("isSale")
        const page = parseInt(params.get("page"))
        const colors = params.getAll("colors").map(color => {
          return {
            attribute: "filterColor",
            value: color
          }
        })
        const sizes = params.getAll("sizes").map(size => {
          return {
            attribute: "displaySize",
            value: size
          }
        })
        const categoryIds = params.getAll("categoryIds").map(id => parseInt(id))
        this.filter.attributes = colors.concat(sizes)
        this.filter.categoryIds = categoryIds

        this.productService.getProductList(page, sortBy, "12", order, this.filter).subscribe((data) => {
          this.products = data.content
          this.totalPageNum = data.totalPages
          this.currentPage = page
        })
      }else {
        //if url params is null
        if(!this.resolverReady || this.categoryIdParam !== +this.route.snapshot.params.categoryId) {
          this.resolverReady = true
        }else {
          this.filter = new ProductSkuFilterRequest()
          this.filter.isSale = params.get("isSale")
          if(this.categoryIdParam !== 0) {
            this.filter.categoryIds.push(this.categoryIdParam)
          }
          this.productService.getProductList(0, "displayOrder,id", "12", 'DESC', this.filter).subscribe((data) => {
            this.products = data.content
            this.totalPageNum = data.totalPages
            this.currentPage = 0
          })
        }
      }
    })
  }

  onPageChange(pageNum: number) {
    this.filterProduct(pageNum, this.sort, this.order, this.filter)
  }

  filterProduct(page: number, sortBy: string, order: string, filter: ProductSkuFilterRequest) {
    //UPDATE url params
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        page: page,
        sortBy: sortBy,
        order: order,
        colors: this.filter.attributes.filter(attr => attr.attribute === "filterColor").map(attr => attr.value),
        sizes: this.filter.attributes.filter(attr => attr.attribute === "displaySize").map(attr => attr.value),
        categoryIds: this.filter.categoryIds
      },
      queryParamsHandling: 'merge',
    });
  }

  getDropdownValueBySortAndOrder(sort: string, order: string): string {
    switch(sort) {
      case "price":
        if(order === "asc") {
          return "Price Low to High"
        }else {
          return "Price High to Low"
        }
      case "popularity":
        return "Most Popular";
      case "createdAt":
        return "New Arrivals";
      default:
        return ""  
    }
  }

  selectFilter(value) {
    this.selectedSort = value
    switch(value){
      case "Price Low to High":
        //price low to high
        this.sort = "price"
        this.order = "asc"
        this.filterProduct(0, this.sort, this.order, this.filter)
        break;
      case "Price High to Low":
        //price high to low
        this.sort = "price"
        this.order = "desc"
        this.filterProduct(0, this.sort, this.order, this.filter)
        break;
      case "Most Popular":
        //Most Popular
        this.sort = "popularity"
        this.order = "desc"
        this.filterProduct(0, this.sort, this.order, this.filter)
        break;
      case "New Arrivals":
        //New Arrivals
        this.sort = "createdAt"
        this.order = "desc"
        this.filterProduct(0, this.sort, this.order, this.filter)
        break;   
      default:
        break;  
    }
  }

  onChangeSize(value) {
    if(this.filter.attributes.findIndex(eav => eav.value === value) < 0) {
      //Add color selected
      this.filter.attributes.push({
        attribute: "displaySize",
        value: value
      })
    }else {
      //Remove color selected
      this.filter.attributes = this.filter.attributes.filter((attribute) => {
        return attribute.value !== value
      })
    }
    this.filterProduct(0, this.sort, this.order, this.filter)
  }

  onChangeColor(value) {
    if(this.filter.attributes.findIndex(eav => eav.value === value) < 0) {
      //Add color selected
      this.filter.attributes.push({
        attribute: "filterColor",
        value: value
      })
    }else {
      //Remove color selected
      this.filter.attributes = this.filter.attributes.filter((attribute) => {
        return attribute.value !== value
      })
    }
    this.filterProduct(0, this.sort, this.order, this.filter)
  }

  onChangeCatgory(value) {
    this.filter.categoryIds = value
    this.filter.attributes = []
    this.filterProduct(0, this.sort, this.order, this.filter)
  }

  resetFilter() {
    //Reset filter
    this.filter = new ProductSkuFilterRequest()
    if(this.categoryIdParam !== 0) {
      this.filter.categoryIds.push(this.categoryIdParam)
    }
    this.currentPage = 0
    this.selectedSort = ""
    this.sort = "displayOrder,id"
    this.order = "desc"
    this.selectedSort = ""
  }

  clearFilter() {
    this.resetFilter()
    this.filterProduct(0, this.sort, this.order, this.filter)
  }

  mobileApplyFilter(value) {
    console.log('value', value)
    this.filter = new ProductSkuFilterRequest()
    this.currentPage = 0
    //Sorting
    switch(value.sort){
      case "Price Low to High":
        //price low to high
        this.sort = "price"
        this.order = "asc"
        break;
      case "Price High to Low":
        //price high to low
        this.sort = "price"
        this.order = "desc"
        break;
      case "Most Popular":
        //Most Popular
        this.sort = "popularity"
        this.order = "desc"
        break;
      case "New Arrivals":
        //New Arrivals
        this.sort = "createdAt"
        this.order = "desc"
        break; 
      default:
        break;  
    }
    //Category
    if(this.categoryIdParam !== 0) {
      if(value.categoryList && value.categoryList.length > 0) {
        value.categoryList.forEach(catId => {
          this.filter.categoryIds.push(catId)
        })
      }else {
        this.filter.categoryIds.push(this.categoryIdParam)
      }
    }

    //Size
    value.sizeList.forEach(size => {
      this.filter.attributes.push({
        attribute: "displaySize",
        value: size
      })
    })
    //Color
    value.colorList.forEach(color => {
      this.filter.attributes.push({
        attribute: "filterColor",
        value: color
      })
    })

    this.filterProduct(0, this.sort, this.order, this.filter)
  }

}
